"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisualizationScale = exports.setVisualizationScale = void 0;
/** @file Track the app's layout */
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    visualizationScale: null,
};
var layoutSlice = (0, toolkit_1.createSlice)({
    name: 'layout',
    initialState: initialState,
    reducers: {
        setVisualizationScale: function (state, action) {
            state.visualizationScale = action.payload;
        },
    },
});
exports.setVisualizationScale = layoutSlice.actions.setVisualizationScale;
var selectSelf = function (state) { return state.layout; };
exports.getVisualizationScale = (0, toolkit_1.createSelector)(selectSelf, function (state) { return state === null || state === void 0 ? void 0 : state.visualizationScale; });
exports.default = layoutSlice.reducer;
